/* eslint-disable react/prop-types */
import { Helmet } from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';

import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Section from '@zg-rentals/multibrand-ui/lib/Section';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import InquiryNotFound from '../../modules/InquiryNotFound';
import pathsManifest from '../../../pathsManifest';
import UserActions from '../../../flux/actions/UserActions';
import ListingActions from '../../../flux/actions/ListingActions';
import queryUtil from '../../../utils/queryUtils';
import SurveyListingCard from '../../modules/SurveyListingCard';
import { logError } from '@zg-rentals/log-error';

const feedbackTypes = {
  YES: 10,
  NO: 13,
};

const feedbackSuccessCategories = {
  NONE: -1,
  ONE_POSITIVE: 0,
  ONE_NEGATIVE: 1,
  MULTIPLE: 2,
};

class InquiryFeedbackPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickDoneButton = this.handleClickDoneButton.bind(this);
    this.handleSubmitFeedback = this.handleSubmitFeedback.bind(this);

    this.state = {
      listingsLoading: true,
      hasSubmittedFeedback: Boolean(props.currentQuery.inquiryFeedbackType),
      listings: [],
    };
  }

  componentDidMount() {
    const { dispatch, currentQuery } = this.props;
    const { inquiryFeedbackType, inquiryId, allInquiryIds, allInquiryIdsHash } = currentQuery;
    let allInquiryIdsArr = decodeURIComponent(allInquiryIds).split(',');
    const body = {
      inquiryIds: allInquiryIdsArr,
      allInquiryIdsHash,
    };
    dispatch(ListingActions.getFeedbackListings(body))
      .then((listings) => {
        for (var i in listings) {
          if (listings[i].inquiryId === inquiryId) {
            listings[i].submittedFeedbackCode = parseInt(inquiryFeedbackType);
          }
        }
        this.setState({
          listingsLoading: false,
          listings,
        });
        return;
      })
      .catch((err) => {
        logError({
          error: err,
          errorType: 'InquiryFeedbackPage',
          context: { location: 'InquiryFeedbackPage#componentDidMount' },
        });
      });
  }

  handleCheckPropertyNotAvailable(checked) {
    if (checked) {
      this.setState({
        showNoLongerAvailableNotif: true,
        notifTimeout: setTimeout(this.hideNotif.bind(this), 4000),
      });
    } else {
      this.hideNotif();
    }
  }

  handleSubmitFeedback(type, inquiryId, hash) {
    const { hasSubmittedFeedback, listings } = this.state;
    const { dispatch } = this.props;

    for (var i in listings) {
      if (listings[i].inquiryId === inquiryId) {
        listings[i].submittedFeedbackCode = type;
      }
    }

    const feedbackBody = {
      submittedFeedbackCode: type,
      hash,
      inquiryId,
    };

    dispatch(UserActions.submitFeedbackWithoutReport(feedbackBody))
      .then(() => {
        if (listings.length > 1) {
          this.setState({
            listings,
          });

          if (!hasSubmittedFeedback) {
            this.setState({
              hasSubmittedFeedback: true,
            });
          }
        } else {
          let feedbackSuccessCategory = feedbackSuccessCategories.NONE;
          let providerListingId = '';
          if (listings[i].submittedFeedbackCode === feedbackTypes.YES) {
            feedbackSuccessCategory = feedbackSuccessCategories.ONE_POSITIVE;
            providerListingId = listings[i].aliasEncoded;
          } else if (listings[i].submittedFeedbackCode === feedbackTypes.NO) {
            feedbackSuccessCategory = feedbackSuccessCategories.ONE_NEGATIVE;
          }
          window.router.transitionTo(
            `${pathsManifest.inquiryFeedbackSuccessPage}?category=${feedbackSuccessCategory}&providerListingId=${providerListingId}`,
            true,
          );
        }
        return;
      })
      .catch((err) => {
        logError({
          error: err,
          errorType: 'InquiryFeedbackPage',
          context: { location: 'InquiryFeedbackPage#handleSubmitFeedback' },
        });
      });
  }

  handleClickDoneButton() {
    const { listings } = this.state;
    let feedbackSuccessCategory = feedbackSuccessCategories.NONE;
    let providerListingId = '';

    for (var i in listings) {
      if (listings[i].submittedFeedbackCode === feedbackTypes.YES) {
        if (feedbackSuccessCategory === feedbackSuccessCategories.NONE) {
          feedbackSuccessCategory = feedbackSuccessCategories.ONE_POSITIVE;
          providerListingId = listings[i].aliasEncoded;
        } else {
          feedbackSuccessCategory = feedbackSuccessCategories.MULTIPLE;
        }
      } else if (listings[i].submittedFeedbackCode === feedbackTypes.NO) {
        if (feedbackSuccessCategory === feedbackSuccessCategories.NONE) {
          feedbackSuccessCategory = feedbackSuccessCategories.ONE_NEGATIVE;
        } else {
          feedbackSuccessCategory = feedbackSuccessCategories.MULTIPLE;
        }
      }
    }
    window.router.transitionTo(
      `${pathsManifest.inquiryFeedbackSuccessPage}?category=${feedbackSuccessCategory}&providerListingId=${providerListingId}`,
      true,
    );
  }

  getDateRange() {
    const {
      currentQuery: { startDate, endDate },
    } = this.props;
    const startDateFormat = format(startDate, 'MMM DD');
    const endDateFormat = format(endDate, 'MMM DD');

    let dateRange = '';
    if (startDate) {
      dateRange = startDateFormat;
    }
    if (startDateFormat !== endDateFormat) {
      dateRange = `${startDateFormat}${`\u2013`}${endDateFormat}`;
    }

    return dateRange;
  }

  render() {
    const { hasSubmittedFeedback, listings, listingsLoading } = this.state;
    const { brand, currentQuery } = this.props;
    const yesButtonText = 'Yes, I did';
    const { totalListings } = currentQuery;
    const dateRange = this.getDateRange();
    if (listingsLoading) {
      return null;
    }

    return listings.length > 0 ? (
      <React.Fragment>
        <Helmet>
          <meta name="robots" content="noindex" />
          <title>Inquiry Feedback</title>
        </Helmet>

        <Section>
          <Center>
            <Row>
              <Col>
                <Text type="h2" emphasize>
                  Did you hear back?
                </Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text type="body" lowlight>
                  Showing {totalListings} properties you recently contacted
                  {dateRange ? ` on ${dateRange}.` : '.'}
                </Text>
              </Col>
            </Row>
          </Center>
        </Section>

        <div>
          {listings.map((listing) => {
            return (
              <Center key={listing.hash}>
                <Row>
                  <Col sm={9} md={8} lg={7}>
                    <SurveyListingCard
                      onSubmitFeedback={this.handleSubmitFeedback}
                      listing={listing}
                      feedbackTypes={feedbackTypes}
                      yesButtonActive={listing.submittedFeedbackCode === feedbackTypes.YES}
                      noButtonActive={listing.submittedFeedbackCode === feedbackTypes.NO}
                      yesButtonText={yesButtonText}
                    />
                  </Col>
                </Row>
              </Center>
            );
          })}
        </div>
        {listings.length > 1 && (
          <Section>
            <Center className="stacked-lg">
              <Row>
                <Col>
                  <Button type="primary" disabled={!hasSubmittedFeedback} onClick={this.handleClickDoneButton}>
                    Done
                  </Button>
                </Col>
              </Row>
            </Center>
          </Section>
        )}
      </React.Fragment>
    ) : (
      <Section>
        <InquiryNotFound brand={brand} />
      </Section>
    );
  }
}

const mapStateToProps = (state) => ({
  currentQuery: queryUtil.parse(state.router.location.search),
  brand: state.app.brand,
  currentArea: state.area.currentArea,
  hostname: state.app.hostname,
});

export default connect(mapStateToProps)(InquiryFeedbackPage);
